import { refresh } from "@/api2/.generated/user/user";
import { getTokenPayload } from "@/lib/common/jwt";
import { tokenStorage } from "@/lib/storage/token";

export const authInterceptor = async () => {
  if (process.env.STORYBOOK) {
    return "mocked-token";
  }

  const { getTokens, setTokens } = tokenStorage();
  const { accessToken } = getTokens();

  const tokenPayload = getTokenPayload(accessToken);
  if (tokenPayload) return accessToken;

  try {
    const { accessToken } = await refresh({
      withCredentials: true
    });

    setTokens({ accessToken });
    return accessToken;
  } catch {
    return null;
  }
};
